// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ojjUL","colBig":"styles_colBig__Muyrm","colSmall":"styles_colSmall__15pev"};